"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.getFirstRegisteredInputByName = getFirstRegisteredInputByName;
var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/find"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/map"));
var _from = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/array/from"));
function getFirstRegisteredInputByName(inputsMap, inputName) {
  var _context, _context2;
  return (0, _find.default)(_context = (0, _map.default)(_context2 = (0, _from.default)(inputsMap)).call(_context2, ([inputElement]) => inputElement)).call(_context, ({
    name
  }) => name === inputName);
}